import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import PageHeader from "../../common/PageHeader/PageHeader";
import { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../common/Context";
import LoadingWheel from "../../common/LoadingWheel/LoadingWheel";
import SponsorCard from "./components/SponsorCard";
import SponsorDDL from "./components/SponsorDDL";

const BLANK_COMPETITION = { title: "Clear", id: 0, sponsors: [] };

const SponsorZone = () => {
  const { t } = useTranslation("SponsorZone");
  const { firebaseState, tabletView } = useContext(GlobalContext);

  const [allCompetitions, setAllCompetitions] = useState([BLANK_COMPETITION]);
  const [selectedCompetition, setSelectedCompetition] = useState({ title: "" });
  const [allCompanies, setAllCompanies] = useState([]);
  const [filteredCompanies, setFilteredCompanies] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);

  const containerStyle = {
    mt: "1rem",
    position: "relative",
    minHeight: "50vh",
  };
  const noSponsorsStyle = {
    pt: "2.5rem",
    borderTop: "1px solid #747474",
  };
  const pageHeaderStyle = {
    "& p": {
      width: tabletView ? "calc(100% - 16rem)" : "auto",
      lineHeight: 1.5,
    },
  };

  useEffect(() => {
    const getAllCompetitions = async () => {
      let result = await firebaseState.getAllCompetitions();
      setAllCompetitions([...allCompetitions, ...result]);
    };
    getAllCompetitions();
  }, [firebaseState]);
  useEffect(() => {
    const getAllCompanies = async () => {
      let result = await firebaseState.getAllCompaniesData();
      setAllCompanies(result);
    };
    getAllCompanies();
  }, [firebaseState]);
  useEffect(() => {
    if (allCompanies.length > 0 && allCompetitions.length > 1) {
      filterCompanies();
      setIsLoaded(true);
    }
  }, [allCompanies, allCompetitions]);
  useEffect(() => {
    if (selectedCompetition.id != undefined && isLoaded) {
      filterCompanies(selectedCompetition);
    }
  }, [selectedCompetition]);

  const filterCompanies = (competition) => {
    if (competition?.id) {
      const sponsorsData = competition.sponsors
        .map((sponsorId) => {
          if (sponsorId != "") {
            const result = allCompanies.find(
              (company) => company.id === sponsorId,
            );
            return result ? result : undefined;
          }
          return undefined;
        })
        .filter(Boolean)
        .sort((a, b) => a.companyName.localeCompare(b.companyName));
      setFilteredCompanies(sponsorsData);
    } else {
      let sponsors = [];
      allCompetitions.map((competition) => {
        if (competition.sponsors) {
          sponsors = [...sponsors, ...competition.sponsors];
        }
      });
      const sponsorsData = sponsors
        .map((sponsorId) => {
          if (sponsorId != "") {
            const result = allCompanies.find(
              (company) => company.id === sponsorId,
            );
            return result ? result : undefined;
          }
          return undefined;
        })
        .filter(Boolean)
        .sort((a, b) => a.companyName.localeCompare(b.companyName));
      setFilteredCompanies(sponsorsData);
    }
  };

  const displayCompany = (company) => {
    return <SponsorCard sponsorData={company} />;
  };

  return (
    <Box sx={containerStyle}>
      <PageHeader
        title={t("sponsorZone")}
        description={t("desc")}
        sx={pageHeaderStyle}
      />
      <Box>
        {isLoaded ? (
          <>
            <SponsorDDL
              data={allCompetitions}
              selected={selectedCompetition}
              handleChange={setSelectedCompetition}
              placeholder={t("selectCompetition")}
            />
            {filteredCompanies.length > 0 ? (
              filteredCompanies.map(displayCompany)
            ) : (
              <Typography sx={noSponsorsStyle}>{t("noSponsors")}</Typography>
            )}
          </>
        ) : (
          <LoadingWheel width={3} />
        )}
      </Box>
    </Box>
  );
};

export default SponsorZone;
